<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    width="1200px"
    :close-on-click-modal="false"
  >
    <div class="form">
      <div class="form-item">
        <div class="label">门店：</div>
        <div class="value">
          <tenantSelector ref="tenantSelector" v-model="filters.tenant" />
        </div>
      </div>
      <div class="form-item">
        <div class="label">时间：</div>
        <div class="value">
          <dateOptionSelector
            size="small"
            v-model="filters.dateTime"
            ref="dateOptionSelector"
            :options="dateOptions"
          />
        </div>
      </div>
      <div class="form-item">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-s-data"
          @click="getData"
          >汇总统计</el-button
        >
      </div>
    </div>
    <el-table stripe :data="rows" border>
      <el-table-column min-width="100" label="预约日期" prop="name">
        <template slot-scope="scope">
          <i
            class="el-icon-date"
            v-if="scope.row.name == '待接单'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-s-promotion"
            v-if="scope.row.name == '待派单'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-message-solid"
            v-if="scope.row.name == '改约中'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-user-solid"
            v-if="scope.row.name == '已派单'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-success"
            v-if="scope.row.name == '已完成'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-money"
            v-if="scope.row.name == '已结算'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-remove"
            v-if="scope.row.name == '已拒绝'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-error"
            v-if="scope.row.name == '已取消'"
            style="color: #67c23a; font-size: 16px"
          />
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        :min-width="80"
        v-for="column in columns"
        :prop="column.prop"
        :label="column.text"
        :key="column.prop"
      >
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
        <script>
import { processAnalysis } from "@/api/analysis.js";
import tenantSelector from "@/components/tenantSelector";
import dateOptionSelector from "@/components/dateOptionSelector";
export default {
  components: {
    tenantSelector,
    dateOptionSelector,
  },
  data() {
    return {
      dateOptions: [{ value: "create", name: "时间区间" }],
      filters: {
        tenant: "",
        dateTime: {
          dateType: "create",
          date: [],
        },
      },
      columns: [],
      rows: [],
      drawerTitle: "订单总览",
      drawerVisible: false,
    };
  },
  methods: {
    show() {
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      const end = new Date();
      this.filters.dateTime.date = [start, end];
      this.loadData();
      this.drawerVisible = true;
    },
    loadData() {
      let param = {
        tenant: this.filters.tenant.Key,
        beginDate: this.filters.dateTime.date[0],
        endDate: this.filters.dateTime.date[1],
      };
      processAnalysis(param)
        .then((res) => {
          if (res) {
            this.rows = res.rows;
            this.columns = res.columns;
          }
        })
        .catch((ex) => {
          this.msg.errorMsg(ex);
        });
    },
  },
  mounted() {},
};
</script>
        <style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>